import * as React from "react"
import { WindowLocation } from "@gatsbyjs/reach-router"
import * as qs from "query-string"
import { Heading, Spacer, Link, GitHubIcon } from "gatsby-interface"
import { MdArrowBack } from "react-icons/md"
import { getPathToCreateSite } from "@modules/site/create/shared/utils"

export function ProvisionConfigurationHeader({
  organizationId,
  location,
  starterName,
  className,
}: {
  organizationId: string
  location: WindowLocation
  starterName: string
  className?: string
}): JSX.Element {
  const goBackTo =
    (qs.parse(location.search).returnTo as string) ||
    getPathToCreateSite(organizationId)

  const goBackLink = {
    to: goBackTo,
    label: "Go Back",
  }

  return (
    <header className={className}>
      <Link
        variant="SIMPLE"
        to={goBackLink.to}
        css={theme => ({
          display: `flex`,
          alignItems: `center`,
          textDecoration: `none`,
          textTransform: `capitalize`,
          svg: {
            marginRight: theme.space[3],
          },
        })}
      >
        <MdArrowBack /> {goBackLink.label}
      </Link>
      <Spacer size={3} />
      <Heading
        as="h2"
        css={_theme => ({
          display: "flex",
          alignItems: "center",
        })}
      >
        Clone{" "}
        <span
          css={theme => ({
            display: "flex",
            marginRight: theme.space[2],
            marginLeft: theme.space[2],
          })}
        >
          <GitHubIcon />
        </span>{" "}
        {starterName}
      </Heading>
    </header>
  )
}
